(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-main-product"]) return;
  try {
    
  const buttonDummy = document.querySelector("#dummy-chat-button");
  buttonDummy.addEventListener("click", () => {
    console.log("abriendo");
  })

  } catch(e) { console.error(e); }
})();
})();
